module.exports = __webpack_public_path__ + "static/img/introduceBTypeCIcon1.60a0dcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeCIcon1.png
// module id = tt26
// module chunks = 0